import { DEV } from "solid-js"
import { Vector3 } from "three"
import Unexpected from "../../../Exception/Unexpected.class"
import type { NeighborWeights } from "../TerrainMesh1V2/NeighborWeights.type"

/**
 * Elevations for the 8 neighbours in the same order as eightDirections.
 * `base` is the elevation of the centre tile.
 */
export type NeighborDirectionVector3Collection = {
  base: Vector3
  avgs: Vector3[]  // length === 8
}

const sum = new Vector3()

/**
 * Weighted interpolation of direction v3s at an arbitrary point inside a tile.
 *
 * @param weights   WeightsV2 from calculateNeighborWeights
 * @param dirV3s    Direction v3s for base + 8 neighbours
 * @returns         The interpolated direction v3
 */
export default function calculateNodeWaterCurrent(
  weights: NeighborWeights,
  dirV3s: NeighborDirectionVector3Collection,
  outV3 : Vector3,
): void {

  const { base: wBase, list: wList, total } = weights
  const { base: eBase, avgs: eList } = dirV3s

  if (DEV) {
    if (wList.length !== 8) {
      throw new Unexpected('wList.length !== 8')
    }
    if (eList.length !== 8) {
      throw new Unexpected('eList.length !== 8')
    }
  }

  sum.copy(eBase).multiplyScalar(wBase)
  for (let i = 0; i < 8; i++) {
    sum.add(eList[i].multiplyScalar(wList[i]))
  }

  if (total > 0) {
    sum.divideScalar(total)
  } else {
    // If total is zero (shouldn’t happen), fall back to base elevation
    sum.copy(eBase)
  }
  sum.divideScalar(2)

  outV3.copy(sum)
}
